import { GlobalAxios } from "../axios/axios-config";
import {
  INewTicketAutomationReceivedMessage,
  ITicketAutomationReceivedMessages,
} from "../models/automation-received-message";

const TICKET_SERVICE_WHATS_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationReceivedMessage/";

export const createTicketAutomationReceivedMessage = (
  item: INewTicketAutomationReceivedMessage
) => {
  return GlobalAxios.post(TICKET_SERVICE_WHATS_ROUTE, item);
};

export const getTicketAutomationReceivedMessageById = (id: string) => {
  return GlobalAxios.get<ITicketAutomationReceivedMessages>(
    TICKET_SERVICE_WHATS_ROUTE + id
  );
};

export const updateTicketAutomationReceivedMessageById = ({
  item,
  id,
}: {
  item: INewTicketAutomationReceivedMessage;
  id: string;
}) => {
  return GlobalAxios.put(TICKET_SERVICE_WHATS_ROUTE + id, item);
};
